import api from "../api/ProductApi";
import * as types from "./ActionTypes";

export const getVirtualProductById = (virtualProductId) => {
    return (dispatch) => {
        return api.getVirtualProductById(virtualProductId)
            .then((response) => {
                dispatch({ type: types.GET_VIRTUAL_PRODUCT_BY_ID_SUCCEEDED, virtualProduct: response });
            })
            .catch((error) => {
                dispatch({ type: types.GET_VIRTUAL_PRODUCT_BY_ID_FAILED, error });
                throw(error);
            });
    };
};

export const getAllVirtualProducts = () => {
    return (dispatch) => {
        return api.getAllVirtualProducts()
            .then((response) => {
                dispatch({ type: types.GET_VIRTUAL_PRODUCTS_SUCCEEDED, virtualProducts: response });
            })
            .catch((error) => {
                dispatch({ type: types.GET_VIRTUAL_PRODUCTS_FAILED, error });
                throw(error);
            });
    };
};

export const getRolesProductById = (productId, productName) => {
    return (dispatch) => {
        return api.getRolesProductById(productId, productName)
            .then((response) => {
                dispatch({ type: types.GET_ROLES_BY_PRODUCT_ID_SUCCEEDED, roles: response, productId: productId, productName: productName });
            })
            .catch((error) => {
                dispatch({ type: types.GET_ROLES_BY_PRODUCT_ID_FAILED, error });
                throw(error);
            });
    };
};
